import { render, staticRenderFns } from "./supplieraccount.vue?vue&type=template&id=aff322fe&scoped=true&"
import script from "./supplieraccount.vue?vue&type=script&lang=js&"
export * from "./supplieraccount.vue?vue&type=script&lang=js&"
import style0 from "./supplieraccount.vue?vue&type=style&index=0&id=aff322fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff322fe",
  null
  
)

export default component.exports